export function isLicenseExpired(license?: {
    expiresAt?: string;
    status?: string;
} | null): boolean {
    return license?.status === "expired" ||
        Boolean(license?.expiresAt && Date.parse(license.expiresAt) <= Date.now());
}

export function getLicenseExpiredMessage(expiresAt?: string): string {
    if (!expiresAt) return "License expired";

    const timestamp = Date.parse(expiresAt);
    if (!Number.isFinite(timestamp)) {
        console.error("Invalid license expiration date", expiresAt);
        return "License expired";
    }

    const date = new Intl.DateTimeFormat("en-GB", {
        day: "numeric",
        month: "short",
        year: "numeric",
        timeZone: "UTC",
    }).format(timestamp);
    return `License expired on ${date}`;
}
